<template>
  <div>
    <el-form
      ref="form"
      label-width="100px"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-form-item label="油卡卡号" prop="gasCardNo">
        <el-input
          clearable
          v-model="formData.gasCardNo"
          placeholder="请输入油卡卡号"
          :disabled="isedit"
        ></el-input>
      </el-form-item>
      <el-form-item label="办卡日期" prop="purchaseDate">
        <el-date-picker
          v-model="formData.purchaseDate"
          type="date"
          placeholder="选择日期"
          style="width:100%;"
          value-format="yyyy-MM-dd"
          :disabled="isedit"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="开户加油站" prop="gasStation">
        <el-input
          clearable
          :maxlength="20"
          v-model="formData.gasStation"
          placeholder="请输入开户加油站"
        ></el-input>
      </el-form-item>
      <el-form-item label="油卡余额" prop="gasCardBalance">
        <el-input-number
          v-model="formData.gasCardBalance"
          size="medium"
          style="width:100%"
          :max="162142895431250380000"
          :step="0.01"
          :min="0.0"
          controls-position="right"
          :precision="2"
        ></el-input-number>
      </el-form-item>

      <el-form-item label="所属机构" prop="orgCode">
        <org-cascader
          :valueString.sync="formData.orgAllCode"
          :lastValue.sync="formData.orgCode"
          filterable
        />
      </el-form-item>

      <el-form-item label="可用状态" prop="gasCardStatus">
        <el-radio-group v-model="formData.gasCardStatus">
          <el-radio label="Y">可用</el-radio>
          <el-radio label="N">不可用</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="备注信息" prop="gasCardRemarks">
        <el-input
          v-model="formData.gasCardRemarks"
          clearable
          :maxlength="70"
          type="textarea"
          rows="3"
          placeholder="请输入备注信息"
        ></el-input>
      </el-form-item>
    </el-form>
    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button @click="save()" type="primary" size="small">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: Boolean,
    gasCardCode: String,
    isedit: Boolean,
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() 
        },
      },
      backDialogVisible: false,
      formData: { gasCardStatus: 'Y' },
      rules: {
        gasCardStatus: [
          { required: true, message: '请选择可以状态', trigger: 'change' },
        ],
        gasCardNo: [
          { required: true, message: '请输入油卡卡号', trigger: 'blur' },
          {
            pattern: /^[0-9A-Za-z]+$/,
            message: '油卡卡号只能为数字、英文字母',
            trigger: 'blur',
          },
        ],
        purchaseDate: [
          { required: true, message: '请选择办卡日期', trigger: 'change' },
        ],
        gasStation: [
          { required: true, message: '请输入开户加油站', trigger: 'blur' },
        ],
        gasCardBalance: [
          { required: true, message: '请输入油卡余额', trigger: 'blur' },
        ],
        orgCode: [
          { required: true, message: '请选择所属机构', trigger: 'change' },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.gasCardCode) return
      this.$api
        .masterGasCardDetailApi({
          gasCardCode: this.gasCardCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      let loadingInstance = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.$api
        .masterGasCardSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
